import * as CONST from '../ActionTypes';

const initialState = {
  couponList: [],
  coupon: {},
};

function coupon(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // クーポン一覧取得
    // -----------------
    case CONST.GET_COUPON_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          couponList: action.payload,
        },
      );
    case CONST.GET_COUPON_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          couponList: [],
        },
      );
    // -----------------
    // クーポン詳細取得
    // -----------------
    case CONST.GET_COUPON_DETAIL_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          coupon: action.payload,
        },
      );
    case CONST.GET_COUPON_DETAIL_FAILURE:
      return Object.assign(
        {},
        state,
        {
          coupon: {},
        },
      );
    default:
      return state;
  }
}

export default coupon;
